import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBan, faCheck, faHeadset,
} from '@fortawesome/free-solid-svg-icons';
import React, { useCallback, useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { CiatAppContext, LogicaContext } from '../../../providers';
import api from '../../../api/req';

function SupportDeskMessage() {
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const { auth } = useContext(CiatAppContext);
  const { ticket } = useContext(LogicaContext);

  const sendRequest = useCallback(
    () => {
      const loader = async () => {
        const r = await api.post('/api/auth/support_message/', auth, {
          logica_token: ticket,
          current_url: window.location.href,
        });
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return true;
      };
      setOpened(false);
      setLoading(true);
      loader()
        .then(() => toast.success('Повідомлення відправлено', {
          theme: 'colored',
        }))
        .catch((e) => toast.error(`При відправленні повідомлення сталася помилка: ${e.message}`))
        .finally(() => setLoading(false));
    },
    [auth, ticket],
  );

  return (
    <>
      <Button
        variant="link"
        className="rounded-circle px-2 py-1 bg-light mx-2 "
        onClick={() => setOpened(true)}
        disabled={loading}
      >
        <FontAwesomeIcon icon={faHeadset} beatFade={loading} />
      </Button>
      <Modal show={opened} onHide={() => setOpened(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Відправка запиту до лінії консультації</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Ви збираєтесь зробити запит до лінії консультації. Продовжити?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={sendRequest}>
            <FontAwesomeIcon icon={faCheck} className="me-2" />
            Так
          </Button>
          <Button variant="secondary" onClick={() => setOpened(false)}>
            <FontAwesomeIcon icon={faBan} className="me-2" />
            Ні
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SupportDeskMessage;
